import React, {Component} from 'react'

import {linkTitle} from './linkService'

export default class Link extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDetails: props.details
        };
    }

    handleToggleDetails = () => {
        this.setState({
            showDetails: !this.state.showDetails
        })
    };

    handleUpdateLink = () => {
        this.props.updateLink(this.newLinkData(), this.props.refreshLinks)
        this.setState({
            showDetails: false
        })
    };

    handleDeleteLink = () => {
        this.props.deleteLink(this.props.id, this.props.refreshLinks)
    };

    newLinkData() {
        var data = new Map();
        data.set("id", this.props.id);
        data.set("title", this.linkTitle.value);
        data.set("url", this.linkUrl.value);
        data.set("author", this.linkAuthor.value);
        data.set("twitterHandle", this.linkTwitter.value);
        data.set("description", this.linkDescription.value);
        return data
    }

    fieldWithLabel = (id, label, field) => {
        return (
            <div style={{marginTop: "5px"}}>
                <label htmlFor={id} style={{display: "block", marginBottom: "2px"}}>{label}</label>
                {field}
            </div>
        )
    };

    withId = (text) => {
        return text + "_" + this.props.id
    };

    lookupTwitterHandle = () => {
        this.props.lookupTwitterHandle(this.linkAuthor.value)
            .then(data => {
                this.setState({
                    twitterHandleBg: "rgba(0, 255, 0, 0.1)"
                });
                this.linkTwitter.value = data.handle;
            })
            .catch(() => {
                this.setState({
                    twitterHandleBg: "rgba(255, 255, 0, 0.1)",
                    twitterHandlePlaceholder: `Unable to find Twitter handle for "${this.linkAuthor.value}", please fill in manually`
                });
            });
    };

    render() {
        return (
            <tr className="moveableElement acceptableElement" id={ this.props.id }>
                <td style={{padding: "8px 20px"}}>
                    <div>
                        <span id="details" style={{cursor: "pointer"}} onClick={this.handleToggleDetails}>
                            { this.state.showDetails ? ("▲") : ("▼") }
                        </span>
                        <span id="duplicate">
                            { this.props.alsoInIssue ? ("(also in issue " + this.props.alsoInIssue + ")") : ("") }
                        </span>
                        &nbsp;
                        <a href={this.props.url} target="_blank">{linkTitle(this.props)}</a>
                        { this.props.description === "" ? (
                            <img id={this.withId("no_desc_icon")} alt="No description" src="/img/edit.svg"
                                 style={{padding: "3px", float: "right", width: "23px", height: "23px"}}
                                 name="no_description"/>
                            ) : (
                            ""
                            )}
                    </div>
                    { this.state.showDetails ? (
                        <div style={{width: "100%"}}>
                            {
                                this.fieldWithLabel(
                                    this.withId("title"),
                                    "Title: ",
                                    (<input id={this.withId("title")}
                                            type="text" defaultValue={this.props.title} style={{width: "100%"}}
                                            ref={(input) => {this.linkTitle = input;}} />))
                            }
                            {
                                this.fieldWithLabel(
                                    this.withId("url"),
                                    "Link: ",
                                    (<input id={this.withId("url")}
                                            type="text" defaultValue={this.props.url} style={{width: "100%"}}
                                            ref={(input) => {this.linkUrl = input;}}/>))
                            }
                            {
                                this.fieldWithLabel(
                                    this.withId("author"),
                                    "Author: ",
                                    (<input id={this.withId("author")}
                                            type="text" defaultValue={this.props.author} style={{width: "100%"}}
                                            ref={(input) => {this.linkAuthor = input;}}
                                            onBlur={this.lookupTwitterHandle}/>))
                            }
                            {
                                this.fieldWithLabel(
                                    this.withId("twitterHandle"),
                                    "Twitter handle: ",
                                    (<input id={this.withId("twitterHandle")}
                                            type="text" defaultValue={this.props.twitterHandle}
                                            placeholder={this.state.twitterHandlePlaceholder}
                                            style={{width: "100%", backgroundColor: this.state.twitterHandleBg}}
                                            ref={(input) => {this.linkTwitter = input;}}/>))
                            }
                            {
                                this.fieldWithLabel(
                                    this.withId("description"),
                                    "Description: ",
                                    (<textarea id={this.withId("description")}
                                               type="text" defaultValue={this.props.description}
                                               style={{width: "100%"}} rows="3"
                                               ref={(input) => {this.linkDescription = input;}}/>))
                            }
                            <div style={{margin: "0 auto", width: "310px"}}>
                                <input type="button" value="Update" className="btn btn-sm btn-success"
                                       style={{marginRight: "10px", width: "150px"}}
                                       onClick={this.handleUpdateLink}/>
                                <input type="button" value="Delete" className="btn btn-sm btn-danger"
                                       style={{width: "150px"}}
                                       onClick={this.handleDeleteLink}/>
                            </div>
                        </div>
                        ) : (
                        <div/>
                        )}
                </td>
            </tr>
        )
    }

}

Link.propTypes = {
    id: React.PropTypes.number.isRequired,
    url: React.PropTypes.string.isRequired,
    author: React.PropTypes.string,
    twitterHandle: React.PropTypes.string,
    description: React.PropTypes.string,
    alsoInIssue: React.PropTypes.string,
    updateLink: React.PropTypes.func.isRequired,
    deleteLink: React.PropTypes.func.isRequired,
    refreshLinks: React.PropTypes.func.isRequired,
    lookupTwitterHandle: React.PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/dashboard/links/Link.js